<template>
  <!-- begin hotel info  -->
  <div class="hotel_info panel_bg base">
    <div class="hotel_info_header">
      <ul>
        <li>
          <h1>{{ showHotelName(bookingCreateParam.hotelInfo.hotelName) }}</h1>
        </li>
        <li>
          <div class="star-rate">
            <span v-if="bookingCreateParam.hotelInfo.standardStar > 0">
              <el-rate v-model="bookingCreateParam.hotelInfo.standardStar" disabled class="my-rate-reform" :colors="['#F2A900', '#F2A900', '#F2A900']">
              </el-rate>
            </span>
            <span v-else>
              <span v-for="n in bookingCreateParam.hotelInfo.starRating" :key="n">
                <svg-icon icon-class="hotel_icon_diamond" style="height: 13px;width:18px;padding-right:0"></svg-icon>
              </span>
            </span>
            <span v-if=" bookingCreateParam.hotelInfo.emissionScore >= 45 && $objBaseInfo.channelId == 'WEB'">
              <span style="margin-right: -.7rem;color: #E7E9EA;">{{ separator }}</span>
              <svg-icon icon-class="emission" style="height: 1.7rem;vertical-align: -0.4em;padding-right: 0;"></svg-icon>
              <span style="color: #222A30; font-family: 'Source Sans Pro'; vertical-align: middle; display: inline-block;">{{ $t("RESULT.EMISSION")}}</span>
            </span>
          </div>
        </li>
        <li v-if="$objBaseInfo.channelId == 'MOBILE'">
          <span v-if=" bookingCreateParam.hotelInfo.emissionScore >= 45">
            <svg-icon icon-class="emission" style="height: 1.7rem;vertical-align: -0.4em;padding-right: 3px;"></svg-icon>
            <span style="color: #222A30; font-family: 'Source-Sans-Pro-Regular'; vertical-align: middle; display: inline-block;">{{ $t("RESULT.EMISSION")}}</span>
          </span>
        </li>
        <li v-if="objBaseInfo.sourceType == 'CRM'">FXId: {{ bookingCreateParam.hotelInfo.hotelcode }}</li>
        <li v-if="$objBaseInfo.channelId == 'WEB'">
          <svg-icon icon-class="phone"></svg-icon>
          <span style="color: #838A90;font-family: 'Source Sans Pro';">{{ bookingCreateParam.hotelInfo.contactNumber }}</span>
        </li>
        <li>
          <svg-icon icon-class="location"></svg-icon>
          <span style="color: #838A90;font-family: 'Source-Sans-Pro-Regular';">{{ showHotelAddress(bookingCreateParam.hotelInfo.address)}}</span>
        </li>
      </ul>
      <div class="div-container" v-if="$objBaseInfo.channelId == 'MOBILE'">
        <span style="font-weight: 600;font-size: 16px;">{{ checkInAt }}</span>
        <span>{{ nights + $t('DATEPICKER.NIGHT') }}</span>
        <span style="font-weight: 600;font-size: 16px;">{{ checkOutAt }}</span>
      </div>
    </div>
    <div class="hotel_info_content">
      <div class="item base">
        <div class="title">{{ $t("BOOKING.ROOMTYPE") }}</div>
        <div class="info">{{bookingCreateParam.hotelInfo.roomName[$t("COMMONPARAM.RESPONSEDATA.SHOWTYPE")]}}</div>
      </div>
      <div class="item base">
        <div class="title">{{ $t("BOOKING.DESCRIPTION") }}</div>
        <div class="info">{{ roomTypeInfo }}</div>
      </div>
      <div class="item base">
        <div class="title">{{ $t("BOOKING.BREAKFAST") }}</div>
        <div class="info">{{ breakfastText }}</div>
      </div>
      <div class="item base">
        <div class="title">{{ $t("BOOKING.RATEPLANDES") }}</div>
        <div class="info" v-if="bookingCreateParam.bookingType == 'normal'">{{ $t("BOOKING.INSTANTCON") }}</div>
        <div class="info" style="color:#FF694B" v-if="bookingCreateParam.bookingType == 'bur'">
          {{ $t("DETAIL.DELAY") }}
          <span style="color:#333f48" v-if="bookingCreateParam.source == 'CWTbur'"> -- {{ $t("BOOKING.BURTIPS2") }}</span>
        </div>
      </div>
      <div class="item base" v-show="bookingCreateParam.hotelInfo.isSupportForeign">
        <div class="title">{{ $t("BOOKING.BOOKINGCONDITIONS") }}</div>
        <div class="info">{{ $t("BOOKING.FOREIGNTRAVEL") }}</div>
      </div>
      <div class="item base" v-show="!bookingCreateParam.hotelInfo.isSupportForeign">
        <div class="title">{{ $t("BOOKING.BOOKINGCONDITIONS") }}</div>
        <div class="info">{{ $t("BOOKING.FOREIGNTRAVELTRUE") }}</div>
      </div>
    </div>
  </div>
<!-- end hotel info  -->
</template>
<script>
import { getNights } from "@/utils/utils.js";
import {
  bookingBreakfastCheck
} from "../../api/bookingData.js";
export default {
  name: "Booking_Header",
  inject: ['ParentData'],
  data(){
    return{
      breakfastText: "", 
      roomTypeInfo: "",
      bookingCreateParam: {
        hotelInfo:{
          hotelName: {}, address: {}, roomName: {}
        }
      },
      checkInAt: "",
      checkOutAt: "",
      nights: 0,
    }
  },
  mounted() {
     //session取值
     let sessionParam = sessionStorage.getItem("createOrder");
    if (!sessionParam) {
      return false;
    }
    //接受上个页面传入的酒店ID 以及房型ID
    let pageParam = JSON.parse(sessionParam);
    this.checkInAt = pageParam.checkInAt;
    this.checkOutAt = pageParam.checkOutAt;
    this.nights = getNights(this.checkOutAt, this.checkInAt);
    this.bookingCreateParam = pageParam.bookingCreateParam;
    console.log("pageParam", pageParam);
    if (this.bookingCreateParam != null && this.bookingCreateParam != undefined) {
      this.getRoomTypeInfo();
    }
     this.breakfastText = this.showHotelBreakfast(
      this.bookingCreateParam.breakfastNum,
      this.bookingCreateParam.breakfastFlag,
      this.bookingCreateParam.breakfast
    );
  },
  watch: {
    "$i18n.locale"() {
      this.getRoomTypeInfo();
    },
  },
  methods: {
    // 房型信息拼接
    getRoomTypeInfo() {
      let info_arr = [];
      if (this.bookingCreateParam.hotelInfo.floor && this.bookingCreateParam.hotelInfo.floor.trim() != "") {
        info_arr.push(
          this.$t("BOOKING.ROOMDESCRIPTION", {
            floor: this.bookingCreateParam.hotelInfo.floor,
          })
        );
      }
      if (this.bookingCreateParam.hotelInfo.area && this.bookingCreateParam.hotelInfo.area.trim() != "") {
        info_arr.push(
          this.$t("BOOKING.ROOMDESCRIPTIONAREA", {
            area: this.bookingCreateParam.hotelInfo.area,
          })
        );
      }
      if (this.bookingCreateParam.hotelInfo.wifi || this.bookingCreateParam.hotelInfo.wifi == 0) {
        this.$t("COMMONPARAM.WIFI.WIFI" + this.bookingCreateParam.hotelInfo.wifi) !=
        "COMMONPARAM.WIFI.WIFI" + this.bookingCreateParam.hotelInfo.wifi
          ? info_arr.push(
              this.$t("COMMONPARAM.WIFI.WIFI" + this.bookingCreateParam.hotelInfo.wifi)
            )
          : "";
      }
      if (this.bookingCreateParam.hotelInfo.hasWindow || this.bookingCreateParam.hotelInfo.hasWindow == 0) {
        this.$t("COMMONPARAM.WINDOW.WINDOW" + this.bookingCreateParam.hotelInfo.hasWindow) !=
        "COMMONPARAM.WINDOW.WINDOW" + this.bookingCreateParam.hotelInfo.hasWindow
          ? info_arr.push(
              this.$t("COMMONPARAM.WINDOW.WINDOW" + this.bookingCreateParam.hotelInfo.hasWindow)
            )
          : "";
      }
      this.roomTypeInfo = info_arr.join(", ");
    },
  },
  computed:{
    objBaseInfo() {
      return this.$objBaseInfo || {};
    },
    separator() {
      return "|";
    },
    showHotelName(){
      return function(hotelName) {
        if(this.objBaseInfo.sourceType == "CRM"){
          if(this.objBaseInfo.isGATCity || this.objBaseInfo.destinationType == "I"){
            return hotelName["zh-CN"]+'(' + hotelName["en"] +')' ;
          }
        }
        return hotelName[this.$t("COMMONPARAM.RESPONSEDATA.SHOWTYPE")];
      };
    },
    showHotelAddress(){
      return function(hotelAddress) {
        if(this.objBaseInfo.sourceType == "CRM"){
          if(this.objBaseInfo.isGATCity || this.objBaseInfo.destinationType == "I"){
            return hotelAddress["zh-CN"]+'(' + hotelAddress["en"] +')' ;
          }
        }
        return hotelAddress[this.$t("COMMONPARAM.RESPONSEDATA.SHOWTYPE")];
      };
    },
    showHotelBreakfast() {
        return function (hotelBreakfastNum, breakfastFlag, breakfast) {
          if (breakfastFlag) {
            if (hotelBreakfastNum === 0) {
              return this.$t("BOOKING.NOBREAKFAST");
            }
            if (hotelBreakfastNum === 99) {
              return this.$t("BOOKING.BREAKFAST99");
            }
            if (hotelBreakfastNum > 0 && hotelBreakfastNum < 99) {
              return this.$t("BOOKING.BREAKFASTNUM", { num: hotelBreakfastNum });
            }
          } else {
            return breakfast
              ? this.$t("BOOKING.BREAKFAST99")
              : this.$t("BOOKING.NOBREAKFAST");
          }
          return "";
        };
    },
  }
}
</script>
<style lang="stylus" scoped>
/* 手机、平板屏幕 */
@media screen and (max-width: 960px) {
  .hotel_info_header {
    font-size: 1.4rem;

    ul {
      display: flex;
      flex-direction: column;  /* 垂直排列 */
      align-items: center;     /* 水平居中 */
      justify-content: center; /* 垂直居中（如果需要） */
      padding: 0;
      margin: 0;
      list-style: none;

      li {
        line-height: 2rem;
        padding-bottom: 0.7rem;
        display: inline-block;
        text-align: center;
        h1 {
          display: inline;
          font-size: 1.8rem;
          font-weight: 600;
          height: 2.5rem;
          line-height: 2.5rem;
          margin-right: 1.3rem;
          color: #222A30;
          font-family: 'Source Sans Pro';
        }

        svg {
          padding-right: 0.5rem;
          width: 1.5rem;
          height: 1.5rem;
          vertical-align: middle;
        }

        svg.star_icon {
          padding-right: 0;
          width: 1.4rem;
          height: 1.4rem;
        }
      }
    }
  }

  .hotel_info {
    padding: 1.3rem;

    .hotel_info_header {
      border-bottom: 0.2rem dashed $bg-color;
    }
  }

  .hotel_info_content {
    display: flex;
    padding: 1.2rem 1.2rem 0;
    font-size: 1.4rem;
    line-height: 20px;
    flex-direction: column;

    .item {
      display: flex;

      &.base:not(:last-child) {
        margin-bottom: 1.3rem;
      }

      .title {
        font-weight: 600;
        width: 15rem;
      }

      .info {
        flex: 1;
      }
    }
  }
  .div-container {
    display: flex;
    justify-content: space-between;  /* 均匀分配在一行 */
    align-items: center;              /* 垂直居中 */
    padding: 10px;                /* 上下10px,左右5px */
    margin: 0;                         /* 如果需要重置margin */
    border-radius: 4px; 
    span {
      /* span 样式，可以根据需要调整 */
      font-size: 14px;
      color: #333;
    }  
  }
}
/* 电脑屏幕 */
@media screen and (min-width: 961px) {
  .hotel_info_header {
    font-size: 1.4rem;

    ul {
      display: flex;
      flex-direction: column;

      li {
        line-height: 2rem;
        padding-bottom: 1.4rem;
        display: inline-block;

        h1 {
          display: inline;
          font-size: 1.8rem;
          font-weight: 600;
          height: 2.5rem;
          line-height: 2.5rem;
          margin-right: 1.3rem;
          color: #222A30;
          font-family: 'Source Sans Pro';
        }

        svg {
          padding-right: 1rem;
          width: 2.4rem;
          height: 2.4rem;
          vertical-align: middle;
        }

        svg.star_icon {
          padding-right: 0;
          width: 1.4rem;
          height: 1.4rem;
        }
      }
    }
  }

  .hotel_info {
    padding: 1.3rem;

    .hotel_info_header {
      border-bottom: 0.2rem dashed $bg-color;
    }
  }

  .hotel_info_content {
    display: flex;
    padding: 1.2rem 1.2rem 0;
    font-size: 1.4rem;
    line-height: 20px;
    flex-direction: column;

    .item {
      display: flex;

      &.base:not(:last-child) {
        margin-bottom: 1.3rem;
      }

      .title {
        color: $text-fill-color;
        width: 15rem;
      }

      .info {
        flex: 1;
      }
    }
  }
  .star-rate {
    margin-top: 1rem;
    display: flex;
    align-items: center; /* 垂直居中对齐 */
    gap: 10px; /* 两个元素之间的间距 */
  }
}
</style>